module.exports = __webpack_public_path__ + "img/15-6DU.5480346.jpg";